module.exports = __webpack_public_path__ + "static/media/Temp-CWU2.e97e9e4f.svg";